import {createSlice} from '@reduxjs/toolkit'

const initialState = {
 data: {},
 status: 'idle',
}

const commonFilterSlice = createSlice({
 name: 'commonFilter',
 initialState,
 reducers: {
  setcommonFilterData: (commonFilter, data) => {
   commonFilter.status = 'Success'
   commonFilter.data = {
    ...commonFilter.data,
    ...data.payload,
   }
  },
 },
})

export const {setcommonFilterData} =
 commonFilterSlice.actions

export default commonFilterSlice.reducer
